<div class="materials-page">

  <!-- Search & Filter Header (Phase 1 redesign) -->
  <materials-search-header
    [materialCategories]="materialCategories || []"
    [searchText]="searchParams.searchText"
    [selectedCategory]="selectedCategoriesMulti.length > 1 ? '' : searchParams.categories"
    [sort]="currentSort"
    [filtersBadgeCount]="filtersBadgeCount"
    (searchTextChange)="onHeaderSearchTextChange($event)"
    (searchSubmit)="doSearch()"
    (searchClear)="onHeaderSearchClear()"
    (categoryChange)="onHeaderCategoryChange($event)"
    (sortChange)="onHeaderSortChange($event)"
    (filtersClick)="onHeaderFiltersClick()"
  ></materials-search-header>

  <!-- Advanced filters panel (Phase 3) -->
  <filters-panel
    [isOpen]="showFiltersPanel"
    [materialCategories]="materialCategories || []"
    [initialSelectedCategories]="selectedCategoriesMulti"
    [initialSelectedSubCategory]="searchParams.subCategories"
    (applied)="onFiltersPanelApplied($event)"
    (cleared)="onFiltersPanelCleared()"
    (closed)="onFiltersPanelClosed()"
  ></filters-panel>

  <!-- Active filters strip (Phase 2 + Phase 3) -->
  <div class="active-filters-strip" *ngIf="hasActiveFilters" role="region" aria-label="Active filters">
    <span class="active-filters-label">Active filters:</span>

    <button type="button" class="active-filter-pill" *ngIf="searchParams.searchText"
      [attr.aria-label]="'Remove search filter: ' + searchParams.searchText"
      (click)="clearActiveFilter('searchText')">
      <span class="pill-label">Search: {{ searchParams.searchText }}</span>
      <i class="material-icons pill-close" aria-hidden="true">close</i>
    </button>

    <ng-container *ngIf="selectedCategoriesMulti.length > 1; else singleCategoryPill">
      <button type="button" class="active-filter-pill" *ngFor="let cat of selectedCategoriesMulti"
        [attr.aria-label]="'Remove category filter: ' + cat"
        (click)="clearActiveFilter('multi', cat)">
        <span class="pill-label">Category: {{ cat }}</span>
        <i class="material-icons pill-close" aria-hidden="true">close</i>
      </button>
    </ng-container>
    <ng-template #singleCategoryPill>
      <button type="button" class="active-filter-pill" *ngIf="searchParams.categories"
        [attr.aria-label]="'Remove category filter: ' + searchParams.categories"
        (click)="clearActiveFilter('category')">
        <span class="pill-label">Category: {{ searchParams.categories }}</span>
        <i class="material-icons pill-close" aria-hidden="true">close</i>
      </button>
    </ng-template>

    <button type="button" class="active-filter-pill" *ngIf="searchParams.subCategories"
      [attr.aria-label]="'Remove subcategory filter: ' + searchParams.subCategories"
      (click)="clearActiveFilter('subCategory')">
      <span class="pill-label">Subcategory: {{ searchParams.subCategories }}</span>
      <i class="material-icons pill-close" aria-hidden="true">close</i>
    </button>

    <button type="button" class="active-filters-clear-all" (click)="clearFilter()" aria-label="Clear all active filters">Clear all</button>
  </div>

  <!-- Toolbar Row -->
  <div class="toolbar-row">
    <div class="toolbar-left">
      <span class="results-count" *ngIf="totalItemsCount > 0">
        <strong>{{ totalItemsCount }}</strong> material{{ totalItemsCount !== 1 ? 's' : '' }}<ng-container *ngIf="hasActiveFilters"> matching</ng-container>
      </span>
      <span class="results-count" *ngIf="totalItemsCount === 0 && !isLoadingResults">No materials found</span>
    </div>
    <div class="toolbar-right">
      <div class="view-toggle desktop-only" role="group" aria-label="View mode">
        <button type="button" class="toggle-btn" [class.is-active]="currentViewMode === '4 Columns'"
          [attr.aria-pressed]="currentViewMode === '4 Columns'"
          aria-label="Grid view"
          (click)="setViewType('4 Columns')"
          matTooltip="Grid view" matTooltipPosition="above">
          <i class="material-icons" aria-hidden="true">grid_view</i>
        </button>
        <button type="button" class="toggle-btn" [class.is-active]="currentViewMode === 'List View'"
          [attr.aria-pressed]="currentViewMode === 'List View'"
          aria-label="List view"
          (click)="setViewType('List View')"
          matTooltip="List view" matTooltipPosition="above">
          <i class="material-icons" aria-hidden="true">view_list</i>
        </button>
      </div>
      <button *ngIf="isAdmin" class="btn-create" (click)="showAddMaterialDialog()">
        <i class="material-icons">add</i>
        <span>Create Material</span>
      </button>
    </div>
  </div>

  <!-- Content Area -->
  <div class="content-area">

    <!-- Loading State -->
    <div class="loading-overlay" *ngIf="isLoadingResults">
      <mat-spinner diameter="48"></mat-spinner>
      <p class="loading-text">Loading materials...</p>
    </div>

    <!-- Grid View -->
    <div class="materials-grid" *ngIf="!isLoadingResults && currentViewMode === '4 Columns' && allMedia?.length">
      <div class="grid-item" *ngFor="let item of allMaterials | paginate: paginationConfig; let i = index; trackBy: trackById">
        <material-card *ngIf="!item?.adToDisplay" [item]="item" [eager]="i === 0" headingLevel="h2"></material-card>
      </div>

      <nav class="grid-pagination" aria-label="Page navigation">
        <pagination-template class="paginationController" #p="paginationApi" (pageChange)="changeThePage($event)">
          <ul class="ngx-pagination">
            <li class="pagination-previous" [class.disabled]="p.isFirstPage()">
              <a *ngIf="!p.isFirstPage()" rel="prev"
                 [href]="getPageHref(p.getCurrent() - 1)"
                 (click)="onPageLinkClick($event, p.getCurrent() - 1, p)">Previous</a>
              <span *ngIf="p.isFirstPage()" aria-disabled="true">Previous</span>
            </li>

            <li *ngFor="let page of p.pages; trackBy: trackByPageValue"
                [class.current]="p.getCurrent() === page.value"
                [class.ellipsis]="page.label === '...'">
              <a *ngIf="p.getCurrent() !== page.value && page.label !== '...'"
                 [href]="getPageHref(page.value)"
                 (click)="onPageLinkClick($event, page.value, p)"
                 [attr.aria-label]="'Go to page ' + page.label">{{ page.label }}</a>
              <span *ngIf="p.getCurrent() === page.value" aria-current="page">{{ page.label }}</span>
              <span *ngIf="page.label === '...' && p.getCurrent() !== page.value">{{ page.label }}</span>
            </li>

            <li class="pagination-next" [class.disabled]="p.isLastPage()">
              <a *ngIf="!p.isLastPage()" rel="next"
                 [href]="getPageHref(p.getCurrent() + 1)"
                 (click)="onPageLinkClick($event, p.getCurrent() + 1, p)">Next</a>
              <span *ngIf="p.isLastPage()" aria-disabled="true">Next</span>
            </li>
          </ul>
        </pagination-template>
      </nav>
    </div>

    <!-- List View -->
    <div class="materials-list" *ngIf="!isLoadingResults && currentViewMode === 'List View' && allMedia?.length">
      <div class="table-wrapper">
        <table mat-table id="view-material-table" class="materials-table" [dataSource]="allMedia" matSort>
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Title</mat-header-cell>
            <mat-cell *matCellDef="let material">
              <div class="table-title-text">{{ material?.title }}</div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="categories">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Categories</mat-header-cell>
            <mat-cell *matCellDef="let material">
              <div class="table-categories">
                <span *ngFor="let _cat of material.categories; let i = index" class="table-cat-chip">
                  {{ _cat?.name }}
                </span>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="sub-categories">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Sub Categories</mat-header-cell>
            <mat-cell *matCellDef="let material">
              <div class="table-categories">
                <span *ngFor="let _cat of material.categories; let i = index" class="table-subcat-chip">
                  {{ _cat?.subCategory }}
                </span>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="view">
            <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
            <mat-cell *matCellDef="let material">
              <button class="table-view-btn" (click)="showMaterialDetail(material)">
                View
                <i class="material-icons">arrow_forward</i>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let material; columns: displayedColumns;" (click)="showMaterialDetail(material)"></mat-row>
        </table>

        <mat-paginator showFirstLastButtons [pageSize]="defaultPageSize" [length]="totalItemsCount" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoadingResults && !allMedia?.length">
      <div class="empty-state-content">
        <i class="material-icons empty-icon">library_books</i>
        <h3>No materials found</h3>
        <p>Try adjusting your filters or search terms to find what you're looking for.</p>
        <button class="btn-clear-empty" *ngIf="hasActiveFilters" (click)="clearFilter()">
          <i class="material-icons">refresh</i>
          Clear all filters
        </button>
      </div>
    </div>
  </div>
</div>
